<template lang="pug">
transition(@enter="enter" @leave="leave")
  .l-map-lotus(
    v-if="show"
  )
    .l-map-lotus__item(
      v-for="item in motionLotus.items"
      :style="styleObject(item)"
    )
      svg(version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" :width="item.width + 'px'" :height="item.height + 'px'" viewBox="0 0 26 26" enable-background="new 0 0 26 26" xml:space="preserve")
        path(:fill="item.color" d="M22,16.3c2.2,0,3-3.3,3-3.3s-0.8-3.3-3-3.3c-1.9,0-3.4,1.5-3.8,1.9c-0.1-0.5-0.3-0.9-0.5-1.3 c0.4,0,2.7,0.1,4.1-1.3c1.4-1.6-0.3-4.5-0.3-4.5s-2.9-1.7-4.4-0.2c-1.3,1.3-1.3,3.6-1.3,4.1c-0.4-0.3-0.9-0.5-1.4-0.6 c0.4-0.4,1.9-1.9,1.9-3.8c0-2.2-3.3-3-3.3-3S9.7,1.8,9.7,4c0,1.9,1.5,3.4,1.9,3.8c-0.5,0.1-0.9,0.3-1.3,0.5c0-0.4,0.1-2.7-1.3-4.1 C7.5,2.6,4.5,4.5,4.5,4.5S2.8,7.4,4.3,8.9c1.3,1.3,3.6,1.3,4.1,1.3c-0.3,0.4-0.5,0.9-0.6,1.4C7.4,11.2,5.9,9.7,4,9.7 C1.8,9.7,1,13,1,13s0.8,3.3,3,3.3c1.9,0,3.4-1.5,3.8-1.9c0.1,0.5,0.3,0.9,0.5,1.3c-0.4,0-2.7-0.1-4.1,1.3c-1.6,1.5,0.3,4.5,0.3,4.5 s2.9,1.7,4.4,0.2c1.3-1.3,1.3-3.6,1.3-4.1c0.4,0.3,0.9,0.5,1.4,0.6c-0.4,0.4-1.9,1.9-1.9,3.8c0,2.2,3.3,3,3.3,3s3.3-0.8,3.3-3 c0-1.9-1.5-3.4-1.9-3.8c0.5-0.1,0.9-0.3,1.3-0.5c0,0.4-0.1,2.7,1.3,4.1c1.6,1.4,4.5-0.3,4.5-0.3s1.7-2.9,0.2-4.4 c-1.3-1.3-3.6-1.3-4.1-1.3c0.3-0.4,0.5-0.9,0.6-1.4C18.6,14.8,20.1,16.3,22,16.3z")


</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-map-lotus
  pos(0,0,5)
  wh()
  pointer-events none
  &__item
    position absolute

</style>


<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent,onMounted,computed,reactive,watch} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import Util from '../../lib/util'

export default defineComponent({
  name:'MapLotus',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    
    const show = computed(()=>{
      return store.ui.state.hotoke
    })

    const motionLotus = reactive({
      items:[
      ]
    })
    const styleObject = computed(()=>{
      return (item)=>{
        return {
          transform:'translate('+(item.x+item.mX)+'px,'+item.y+'px) rotate('+item.rotate+'deg)'
        }
      }
    })
    const createLotus = (baseX,baseY,margin)=>{
      const size = store.browser.state.responsive == 'pc' ? 26 : 48
      let scale = Math.random() * 0.35 + 0.75
      const width = size * scale
      const height = size * scale
      
      return {
        color:Math.random() > 0.5 ? '#A28A3E' : '#FFFFFF',
        scale:scale,
        width:width,
        height:height,
        x:baseX + Math.random() * margin - margin/2,
        y:baseY + Math.random() * margin - margin/2,
        // x:baseX,
        // y:baseY,
        mX:0,
        rotate:0,
        speed: Math.random() * 0.2 + 0.2,
        speedMultiply:1
      }
    }
    const createMotionLotus = (wW,wH)=>{
      //モーション用雲
      const xMargin = 200
      const yMargin = 200
      const xCount = Math.floor(wW / xMargin) + 1
      const yCount = Math.floor(wH / yMargin) + 1
      motionLotus.items = []
      for(let x=0;x<xCount;x++){
        for(let y=0;y<yCount;y++){
          let baseX = x * xMargin
          let baseY = y * yMargin
          let lotus = createLotus(baseX,baseY,xMargin)
          motionLotus.items.push(lotus)
        }
      }
      motionLotus.items = Util.shuffle(motionLotus.items)
    }

    let sidResizeHandler = 0
    const resizeHandler = (wW,wH,isFirst=false)=>{
      clearTimeout(sidResizeHandler)

      if(isFirst){
        //蓮
        createMotionLotus(wW,wH)
      } else {
        sidResizeHandler = setTimeout(() => {
          //蓮
          createMotionLotus(wW,wH)
        }, 100);
      }
    }

    const update = (e)=>{
      if(store.ui.state.hotoke){
        for(let i=0;i<motionLotus.items.length;i++){
          let v = motionLotus.items[i]
          v.y += v.speed * v.speedMultiply
          v.rotate = v.y * 1
          // v.mX = Math.sin(v.y * 0.05) * 4
          if(v.y > store.browser.state.windowHeight + v.width){
            v.y = -v.width
          }
        }
      }
      
      window.requestAnimationFrame(update)
    }

    watch(
      ()=> [store.browser.state.windowWidth,store.browser.state.windowHeight],
      (value) => {
        const wW = value[0]
        const wH = value[1]
        resizeHandler(wW,wH);
      }
    )

    onMounted(()=>{
      resizeHandler(store.browser.state.windowWidth,store.browser.state.windowHeight,true)
      update()
    })

    const enter = (el, done)=> {
      gsap.fromTo(
        el,
        {opacity:0},
        {opacity:1,duration:0.3,delay:store.ui.state.kumoMotionDurationAll/1000,ease:'linear',onComplete:()=>{
          done()
        }}
      )
    }
    const leave = (el, done)=> {
      gsap.to(
        el,
        {opacity:0,duration:0.3,delay:0,ease:'linear',onComplete:()=>{
          done()
        }}
      )
    }


    return{
      show,
      motionLotus,
      styleObject,
      enter,
      leave
    }
  }
})
</script>
